// # Tutor routes configuration
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute';

// # Import tutor components
import TutorDashboard from '../../roles/employees/tutor/tutor_dashboard';

// # Import shared components
import Profile from '../../general/profile/profile';
import Settings from '../../general/gen_pages/settings';
import UnderConstruction from '../../components/UnderConstruction';

// # Import general components that are shared across roles
import MyBookmarks from '../../general/bookmarks/my_bookmarks';
import BookmarkPage from '../../general/bookmarks/bookmark_page';
import BookmarkCalendar from '../../general/bookmarks/bookmark_calendar';
import MyFlashcards from '../../general/flashcards/my_flashcards';

// # Import mentorship components
import MenteesList from '../../roles/admin/mentor/sections/mentees_list';
import MentorCalendar from '../../roles/admin/mentor/sections/mentor_calendar';
import MentorMeetings from '../../roles/admin/mentor/sections/mentor_meetings';
import MySpace from '../../roles/admin/mentor/sections/my_space';

// # Import mentee components for tutor viewing
import NeoMenteeStep1 from '../../neo_mentorship/neo_m_step1/neo_mentee_step1';
import NeoMenteeStep2 from '../../neo_mentorship/neo_m_step2/neo_mentee_step2';
import NeoTime from '../../neo_mentorship/common/neo_time';
import M1Calendar from '../../neo_mentorship/neo_m_step1/mentoring1/m1_calendar';
import M2Calendar from '../../neo_mentorship/neo_m_step2/mentoring2/m2_calendar';
import MenteeStats1 from '../../neo_mentorship/neo_m_step1/M_stats1/mentee_stats1';
import MenteeStats2 from '../../neo_mentorship/neo_m_step2/M_stats2/mentee_stats2';
import MenteeMeetings1 from '../../neo_mentorship/neo_m_step1/management1/mentee_meetings1';
import MenteeMeetings2 from '../../neo_mentorship/neo_m_step2/management2/mentee_meetings2';
import Counter1 from '../../neo_mentorship/neo_m_step1/mentoring1/counter1';
import Counter1Page from '../../neo_mentorship/neo_m_step1/mentoring1/counter1_page';
import Counter2 from '../../neo_mentorship/neo_m_step2/mentoring2/counter2';
import Counter2Page from '../../neo_mentorship/neo_m_step2/mentoring2/counter2_page';
import MenteeTasks1 from '../../neo_mentorship/neo_m_step1/mentoring1/mentee_tasks1';

// # Import management components
import Dedicated1 from '../../neo_mentorship/neo_m_step1/management1/dedicated1';
import WeakSpots1 from '../../neo_mentorship/neo_m_step1/management1/weakspots1';
import Checklist1 from '../../neo_mentorship/neo_m_step1/management1/checklist1';
import Assignments1 from '../../neo_mentorship/neo_m_step1/assignments1/assignments1';
import Dedicated2 from '../../neo_mentorship/neo_m_step2/management2/dedicated2';
import WeakSpots2 from '../../neo_mentorship/neo_m_step2/management2/weakspots2';
import Checklist2 from '../../neo_mentorship/neo_m_step2/management2/checklist2';
import Assignments2 from '../../neo_mentorship/neo_m_step2/assignments2/assignments2';

// # Import tutor-specific components
import MentorNotes1 from '../../neo_mentorship/neo_m_step1/tutora1/mentor_notes1';
import GiveDedicated1 from '../../neo_mentorship/neo_m_step1/tutora1/give_dedic1';
import GiveAssignment1 from '../../neo_mentorship/neo_m_step1/assignments1/give_assign1';
import Tasks1 from '../../neo_mentorship/neo_m_step1/tutora1/tasks1';
import TaskChapter1 from '../../neo_mentorship/neo_m_step1/tutora1/task_chapter1';
import MentorNotes2 from '../../neo_mentorship/neo_m_step2/tutora2/mentor_notes2';
import GiveDedicated2 from '../../neo_mentorship/neo_m_step2/tutora2/give_dedic2';
import GiveAssignment2 from '../../neo_mentorship/neo_m_step2/assignments2/give_assign2';
import Tasks2 from '../../neo_mentorship/neo_m_step2/tutora2/tasks2';
import TaskChapter2 from '../../neo_mentorship/neo_m_step2/tutora2/task_chapter2';

// # Import QBank components
import UWorldQBankStep1 from '../../neo_mentorship/neo_m_step1/qbanks1/uw1';
import AmbossQBankStep1 from '../../neo_mentorship/neo_m_step1/qbanks1/amboss1';
import NBMEQBankStep1 from '../../neo_mentorship/neo_m_step1/qbanks1/nbme1';
import UWorldQBankStep2 from '../../neo_mentorship/neo_m_step2/qbanks2/uw2';
import AmbossQBankStep2 from '../../neo_mentorship/neo_m_step2/qbanks2/amboss2';
import NBMEQBankStep2 from '../../neo_mentorship/neo_m_step2/qbanks2/nbme2';

// # Tutor routes component
const TutorRoutes = () => {
  return (
    <Routes>
      {/* # Main dashboard */}
      <Route path="/" element={
        <ProtectedRoute requiredRole="tutor">
          <TutorDashboard />
        </ProtectedRoute>
      } />

      {/* # Profile and Settings */}
      <Route path="/profile" element={
        <ProtectedRoute requiredRole="tutor">
          <Profile />
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute requiredRole="tutor">
          <Settings />
        </ProtectedRoute>
      } />

      {/* # USMLE Resources */}
      <Route path="/library/step1" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Step 1 Library" />
        </ProtectedRoute>
      } />
      <Route path="/library/step2" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Step 2 Library" />
        </ProtectedRoute>
      } />
      <Route path="/mentorship/step1" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Step 1 Mentorship" />
        </ProtectedRoute>
      } />
      <Route path="/mentorship/step2" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Step 2 Mentorship" />
        </ProtectedRoute>
      } />

      {/* # Personal Tools */}
      <Route path="/notes" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Notes" />
        </ProtectedRoute>
      } />
      <Route path="/labs" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Labs" />
        </ProtectedRoute>
      } />
      
      {/* # Bookmarks */}
      <Route path="/bookmarks" element={
        <ProtectedRoute requiredRole="tutor">
          <MyBookmarks />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/general" element={
        <ProtectedRoute requiredRole="tutor">
          <BookmarkPage type="general" />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/step1" element={
        <ProtectedRoute requiredRole="tutor">
          <BookmarkPage type="step1" />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/step2" element={
        <ProtectedRoute requiredRole="tutor">
          <BookmarkPage type="step2" />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/calendar" element={
        <ProtectedRoute requiredRole="tutor">
          <BookmarkCalendar />
        </ProtectedRoute>
      } />
      
      {/* # Flashcards */}
      <Route path="/flashcards" element={
        <ProtectedRoute requiredRole="tutor">
          <MyFlashcards />
        </ProtectedRoute>
      } />

      {/* # Mentor-specific routes */}
      {/* # For direct path /tutor/mentorship/* */}
      <Route path="mentorship/calendar" element={
        <ProtectedRoute requiredRole="tutor">
          <MentorCalendar />
        </ProtectedRoute>
      } />
      <Route path="mentorship/meetings" element={
        <ProtectedRoute requiredRole="tutor">
          <MentorMeetings />
        </ProtectedRoute>
      } />
      <Route path="mentorship/mentees" element={
        <ProtectedRoute requiredRole="tutor">
          <MenteesList />
        </ProtectedRoute>
      } />
      <Route path="mentorship/study" element={
        <ProtectedRoute requiredRole="tutor">
          <MySpace />
        </ProtectedRoute>
      } />

      {/* # For /tutor-dashboard/mentorship/* */}
      <Route path="/mentorship/calendar" element={
        <ProtectedRoute requiredRole="tutor">
          <MentorCalendar />
        </ProtectedRoute>
      } />
      <Route path="/mentorship/meetings" element={
        <ProtectedRoute requiredRole="tutor">
          <MentorMeetings />
        </ProtectedRoute>
      } />
      <Route path="/mentorship/mentees" element={
        <ProtectedRoute requiredRole="tutor">
          <MenteesList />
        </ProtectedRoute>
      } />
      <Route path="/mentorship/study" element={
        <ProtectedRoute requiredRole="tutor">
          <MySpace />
        </ProtectedRoute>
      } />

      {/* # Community */}
      <Route path="/community/notes" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Taking Notes" />
        </ProtectedRoute>
      } />
      <Route path="/community/guide" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Guide" />
        </ProtectedRoute>
      } />
      <Route path="/community/break" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Take a Break" />
        </ProtectedRoute>
      } />
      <Route path="/community/roadmaps" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Roadmaps" />
        </ProtectedRoute>
      } />
      <Route path="/community/updates" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Content Updates" />
        </ProtectedRoute>
      } />
      <Route path="/community/rotations" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Clinical Rotations" />
        </ProtectedRoute>
      } />
      <Route path="/community/experiences" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Experiences" />
        </ProtectedRoute>
      } />

      {/* # Blog */}
      <Route path="/blog/posts" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Admin Posts" />
        </ProtectedRoute>
      } />
      <Route path="/blog/qa" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Q & A" />
        </ProtectedRoute>
      } />
      <Route path="/blog/discussions" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Discussions" />
        </ProtectedRoute>
      } />

      {/* # Extras */}
      <Route path="/extras/gallery" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Gallery" />
        </ProtectedRoute>
      } />
      <Route path="/extras/clinical" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Clinical Library" />
        </ProtectedRoute>
      } />
      <Route path="/extras/research" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Research Library" />
        </ProtectedRoute>
      } />
      <Route path="/extras/oet" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="OET" />
        </ProtectedRoute>
      } />

      {/* # Support */}
      <Route path="/support" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Support" />
        </ProtectedRoute>
      } />
      <Route path="/feedback" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Feedback" />
        </ProtectedRoute>
      } />
      <Route path="/reviews" element={
        <ProtectedRoute requiredRole="tutor">
          <UnderConstruction pageName="Reviews" />
        </ProtectedRoute>
      } />

      {/* # Add mentee viewing routes */}
      <Route path="/mentorship/step1/:username/*">
        <Route 
          index
          element={
            <ProtectedRoute requiredRole="tutor">
              <NeoMenteeStep1 isAdmin={false} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # Add all the necessary sub-routes for Step 1 */}
        <Route 
          path="calendar" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <M1Calendar 
                isAdmin={false} 
                isTutor={true} 
                isMentorView={true} 
                menteeId={sessionStorage.getItem('currentViewingMenteeId')} 
              />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="time" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <NeoTime stepType="Step 1" isAdmin={false} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="stats" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <MenteeStats1 
                isAdmin={false} 
                isTutor={true} 
                isMentorView={true}
                targetUserId={sessionStorage.getItem('currentViewingMenteeId')} 
              />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="meetings" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <MenteeMeetings1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # Management routes for Step 1 */}
        <Route 
          path="plan" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <Dedicated1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="weakspots" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <WeakSpots1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="checklist" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <Checklist1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="assignments" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <Assignments1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # Tutor-specific routes */}
        <Route 
          path="notes" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <MentorNotes1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="dedicated-tasks" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <GiveDedicated1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="give-assignment" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <GiveAssignment1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="tasks" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <Tasks1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="tutora1/chapter/:chapterId" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <TaskChapter1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # Add route for task chapters with username in URL for tutors */}
        <Route 
          path="tutora1/:username/chapter/:chapterId" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <TaskChapter1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # Mentoring routes for Step 1 */}
        <Route 
          path="mentoring1/counter1" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <Counter1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="mentoring1/counter1/:chapterId" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <Counter1Page isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="mentoring1/tasks" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <MenteeTasks1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # QBank routes for Step 1 */}
        <Route 
          path="uworld" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <UWorldQBankStep1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="amboss" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <AmbossQBankStep1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="nbme" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <NBMEQBankStep1 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # Add other Step 1 routes following the same pattern */}
      </Route>

      <Route path="/mentorship/step2/:username/*">
        <Route 
          index
          element={
            <ProtectedRoute requiredRole="tutor">
              <NeoMenteeStep2 isAdmin={false} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # Add all the necessary sub-routes for Step 2 */}
        <Route 
          path="calendar" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <M2Calendar isAdmin={false} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="time" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <NeoTime stepType="Step 2" isAdmin={false} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="stats" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <MenteeStats2 isAdmin={false} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="meetings" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <MenteeMeetings2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # Management routes for Step 2 */}
        <Route 
          path="plan" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <Dedicated2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="weakspots" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <WeakSpots2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="checklist" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <Checklist2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="assignments" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <Assignments2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # Tutor-specific routes for Step 2 */}
        <Route 
          path="notes" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <MentorNotes2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="dedicated-tasks" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <GiveDedicated2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="give-assignment" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <GiveAssignment2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="tasks" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <Tasks2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="tutora2/chapter/:chapterId" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <TaskChapter2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # Mentoring routes for Step 2 */}
        <Route 
          path="mentoring2/counter2" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <Counter2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="mentoring2/counter2/:chapterId" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <Counter2Page isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # QBank routes for Step 2 */}
        <Route 
          path="uworld" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <UWorldQBankStep2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="amboss" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <AmbossQBankStep2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="nbme" 
          element={
            <ProtectedRoute requiredRole="tutor">
              <NBMEQBankStep2 isAdmin={false} isTutor={true} isMentorView={true} />
            </ProtectedRoute>
          } 
        />
        {/* # Add other Step 2 routes following the same pattern */}
      </Route>

      {/* # Step 1 Mentorship Routes */}
      <Route path="mentorship/step1/mentoring1/counter1" element={
        <ProtectedRoute requiredRole="tutor">
          <Counter1 isTutor={true} />
        </ProtectedRoute>
      } />
      <Route path="mentorship/step1/mentoring1/counter1/:chapterId" element={
        <ProtectedRoute requiredRole="tutor">
          <Counter1Page isTutor={true} />
        </ProtectedRoute>
      } />

      {/* # Catch-all route */}
      <Route path="*" element={<Navigate to="/tutor" replace />} />
    </Routes>
  );
};

export default TutorRoutes;
